import DataExtractionFieldBase from './DataExtractionFieldBase';

export const __typename = 'DataExtractionFieldHeaderDto';
export default class DataExtractionFieldHeader extends DataExtractionFieldBase {
  constructor(data = {}) {
    super({ ...data, __typename });
  }
}
